import { render } from "./TestKanbanTopHeaderButton.vue?vue&type=template&id=d651b51e&scoped=true"
import script from "./TestKanbanTopHeaderButton.vue?vue&type=script&lang=js"
export * from "./TestKanbanTopHeaderButton.vue?vue&type=script&lang=js"

import "./TestKanbanTopHeaderButton.vue?vue&type=style&index=0&id=d651b51e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d651b51e"]])

export default __exports__